export class BilheteConsumidorModel {
    public num_bilhete_consumidor: string;
    public qtd_bilhetes: number;
    public seq_sorteio_premiacao_consumidor: number;
    public des_tipo_sorteio_premiacao_consumidor: string;
    public des_situacao_sorteio_premiacao_consumidor: string;
    public dtc_previsao_sorteio_premiacao_consumidor: Date;
    public cod_tipo_origem_bilhete_consumidor: number;
    public des_tipo_origem_bilhete_consumidor: string;
    public cod_situacao_sorteio_premiacao_consumidor: number;
    public seq_premio_sorteio_premiacao_consumidor?: number;
    public num_sorteio_premiacao_consumidor?: number;
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/consumidor-bilhetes.model.ts